export const Svg_103 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M54.542 67.083v-8.75h-8.75v-4.375h8.75v-8.75h4.375v8.75h8.75v4.375h-8.75v8.75h-4.375Zm0-29.094V11.666h4.375V37.99h-4.375ZM12.25 58.333V11.666h4.375v46.667H12.25Zm21.146-35.948V11.666h4.375v10.719h-4.375Zm0 17.937V29.604h4.375v10.718h-4.375Zm0 18.01v-10.79h4.375v10.79h-4.375Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={25.065}
        x2={51.388}
        y1={19.979}
        y2={62.58}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)